import { buildApiUrl } from '../../services/apiConfig';

class MetadataExtractionService {
  constructor() {
    this.API_HOST = process.env.GCP_WELLS_FARGO_API_URL;
  }

  async getModels() {
    const response = await fetch(buildApiUrl('METADATA', '/api/models'));
    if (!response.ok) {
      throw new Error(`Failed to fetch models: ${response.status}`);
    }
    return response.json();
  }

  async sendQuery(question, primaryModel, secondaryModel) {
    const response = await fetch(buildApiUrl('METADATA', '/api/query'), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        question,
        primary_model: primaryModel,
        secondary_model: secondaryModel,
        include_graph: true,
        include_raw_data: true
      }),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || 'Failed to process your request.');
    }

    return response.json();
  }

  async executeSqlQuery(sqlQuery) {
    const response = await fetch(buildApiUrl('SQL', '/run-sql'), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        query: sqlQuery
      }),
    });

    if (!response.ok) {
      throw new Error('Failed to execute SQL query');
    }

    return response.json();
  }

  async uploadMetadataFile(file) {
    const formData = new FormData();
    formData.append('file', file);

    const response = await fetch(buildApiUrl('METADATA', '/api/upload/metadata'), {
      method: 'POST',
      body: formData,
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || 'Failed to upload metadata file');
    }

    return response.json();
  }

  async uploadProcedureFile(file, databaseName) {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('database', databaseName);

    const response = await fetch(buildApiUrl('METADATA', '/api/upload/procedure'), {
      method: 'POST',
      body: formData,
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || 'Failed to upload procedure file');
    }

    return response.json();
  }
}

export default new MetadataExtractionService();